/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fRuRbcdHVNMtdcnFK96ivt
// Component: yzRkzInaRral
import * as React from "react";
import {
  PlasmicLink as PlasmicLink__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/projectcss
import sty from "./PlasmicButtonSecondary.module.css"; // plasmic-import: yzRkzInaRral/css

createPlasmicElementProxy;

export const PlasmicButtonSecondary__VariantProps = new Array("color");

export const PlasmicButtonSecondary__ArgProps = new Array(
  "onClick",
  "disabled",
  "name",
  "content"
);

const $$ = {};

function PlasmicButtonSecondary__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          disabled: false,
          content: "link button"
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "color",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.color
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"wrapp"}
      data-plasmic-override={overrides.wrapp}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.wrapp,
        {
          [sty.wrappcolor_primaryBrand]: hasVariant(
            $state,
            "color",
            "primaryBrand"
          ),
          [sty.wrappcolor_primaryGrey]: hasVariant(
            $state,
            "color",
            "primaryGrey"
          ),
          [sty.wrappcolor_secondary]: hasVariant($state, "color", "secondary"),
          [sty.wrappcolor_tertiary]: hasVariant($state, "color", "tertiary")
        }
      )}
    >
      <div
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.text__vZBu,
          {
            [sty.textcolor_primaryBrand__vZBuZniRs]: hasVariant(
              $state,
              "color",
              "primaryBrand"
            ),
            [sty.textcolor_primaryGrey__vZBuVTff]: hasVariant(
              $state,
              "color",
              "primaryGrey"
            ),
            [sty.textcolor_primaryLight__vZBu0J1Qy]: hasVariant(
              $state,
              "color",
              "primaryLight"
            ),
            [sty.textcolor_primary__vZBuZ31Rc]: hasVariant(
              $state,
              "color",
              "primary"
            ),
            [sty.textcolor_secondary__vZBuC5PWe]: hasVariant(
              $state,
              "color",
              "secondary"
            ),
            [sty.textcolor_tertiary__vZBu9Q3Em]: hasVariant(
              $state,
              "color",
              "tertiary"
            )
          }
        )}
      >
        {"["}
      </div>
      <PlasmicLink__
        data-plasmic-name={"link"}
        data-plasmic-override={overrides.link}
        className={classNames(
          projectcss.all,
          projectcss.a,
          projectcss.a__fRuRb,
          projectcss.__wab_text,
          sty.link,
          {
            [sty.linkcolor_primaryBrand]: hasVariant(
              $state,
              "color",
              "primaryBrand"
            ),
            [sty.linkcolor_primaryGrey]: hasVariant(
              $state,
              "color",
              "primaryGrey"
            ),
            [sty.linkcolor_primaryLight]: hasVariant(
              $state,
              "color",
              "primaryLight"
            ),
            [sty.linkcolor_primary]: hasVariant($state, "color", "primary"),
            [sty.linkcolor_secondary]: hasVariant($state, "color", "secondary"),
            [sty.linkcolor_tertiary]: hasVariant($state, "color", "tertiary")
          }
        )}
        disabled={(() => {
          try {
            return $props.disabled;
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return undefined;
            }
            throw e;
          }
        })()}
        name={(() => {
          try {
            return $props.name;
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return undefined;
            }
            throw e;
          }
        })()}
        onClick={async event => {
          const $steps = {};
          $steps["runOnClick"] = true
            ? (() => {
                const actionArgs = { eventRef: $props["onClick"] };
                return (({ eventRef, args }) => {
                  return eventRef?.(...(args ?? []));
                })?.apply(null, [actionArgs]);
              })()
            : undefined;
          if (
            $steps["runOnClick"] != null &&
            typeof $steps["runOnClick"] === "object" &&
            typeof $steps["runOnClick"].then === "function"
          ) {
            $steps["runOnClick"] = await $steps["runOnClick"];
          }
        }}
        platform={"react"}
      >
        <React.Fragment>
          {(() => {
            try {
              return $props.content;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return "continue";
              }
              throw e;
            }
          })()}
        </React.Fragment>
      </PlasmicLink__>
      <div
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.text__saqJo,
          {
            [sty.textcolor_primaryBrand__saqJozniRs]: hasVariant(
              $state,
              "color",
              "primaryBrand"
            ),
            [sty.textcolor_primaryGrey__saqJoVTff]: hasVariant(
              $state,
              "color",
              "primaryGrey"
            ),
            [sty.textcolor_primaryLight__saqJo0J1Qy]: hasVariant(
              $state,
              "color",
              "primaryLight"
            ),
            [sty.textcolor_primary__saqJoZ31Rc]: hasVariant(
              $state,
              "color",
              "primary"
            ),
            [sty.textcolor_secondary__saqJoc5PWe]: hasVariant(
              $state,
              "color",
              "secondary"
            ),
            [sty.textcolor_tertiary__saqJo9Q3Em]: hasVariant(
              $state,
              "color",
              "tertiary"
            )
          }
        )}
      >
        {"]"}
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  wrapp: ["wrapp", "link"],
  link: ["link"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicButtonSecondary__ArgProps,
          internalVariantPropNames: PlasmicButtonSecondary__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicButtonSecondary__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "wrapp") {
    func.displayName = "PlasmicButtonSecondary";
  } else {
    func.displayName = `PlasmicButtonSecondary.${nodeName}`;
  }
  return func;
}

export const PlasmicButtonSecondary = Object.assign(
  // Top-level PlasmicButtonSecondary renders the root element
  makeNodeComponent("wrapp"),
  {
    // Helper components rendering sub-elements
    link: makeNodeComponent("link"),
    // Metadata about props expected for PlasmicButtonSecondary
    internalVariantProps: PlasmicButtonSecondary__VariantProps,
    internalArgProps: PlasmicButtonSecondary__ArgProps
  }
);

export default PlasmicButtonSecondary;
/* prettier-ignore-end */
